/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Ad_Trim_To_DurationInputs */

const en_shortcut_keys_name_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim To Audio Duration`)
};

const fr_shortcut_keys_name_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapter a la duree audio`)
};

const de_shortcut_keys_name_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Audiodauer zuschneiden`)
};

const it_shortcut_keys_name_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ritaglia in base alla durata audio`)
};

const ru_shortcut_keys_name_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обрезать до длительности звука`)
};

const es_shortcut_keys_name_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortar a la duración del audio`)
};

const zh_cn2_shortcut_keys_name_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`裁剪至音频时长`)
};

const ja_shortcut_keys_name_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオの長さに合わせてトリム`)
};

const hi_shortcut_keys_name_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो की अवधि के अनुसार ट्रिम करें`)
};

const pt_pt2_shortcut_keys_name_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cortar para a duração do áudio`)
};

/**
* | output |
* | --- |
* | "Trim To Audio Duration" |
*
* @param {Shortcut_Keys_Name_Ad_Trim_To_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_ad_trim_to_duration = /** @type {((inputs?: Shortcut_Keys_Name_Ad_Trim_To_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Ad_Trim_To_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_ad_trim_to_duration(inputs)
	if (locale === "de") return de_shortcut_keys_name_ad_trim_to_duration(inputs)
	if (locale === "it") return it_shortcut_keys_name_ad_trim_to_duration(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_ad_trim_to_duration(inputs)
	if (locale === "es") return es_shortcut_keys_name_ad_trim_to_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_ad_trim_to_duration(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_ad_trim_to_duration(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_ad_trim_to_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_ad_trim_to_duration(inputs)
	return en_shortcut_keys_name_ad_trim_to_duration(inputs)
});